import { MimeType } from './attachment';

export interface IExtParam<T = any> {
	id: number;
	name: string;
	type: ExtParamTypeEnum;
	order?: number;
	value: T;
	displayValue?: string;
	isHidden?: boolean;
	colsWidth?: number;
}

export enum ExtParamTypeEnum {
	lookUpField = 'LookUpField',
	textArea = 'TextArea',
	textareaWOFormat = 'TextareaWOFormat',
	multiSlctSubcatTasks = 'MultiSlctSubcatTasks',
	datetime = 'Datetime',
	select = 'Select',
	table = 'Table',
	number = 'Number',
	numericValue = 'NumericValue',
	text = 'Text',
	checkbox = 'Checkbox',
	url = 'URL',
	file = 'File',
	date = 'Date',
}

export interface IExtParamFileValue {
	uploadId: number;
	fileName: string;
	fileMime: MimeType;
	fileSize: number;
}
